import { IAppointmentScheduleResponse, IPatientDetail, IPrescription } from "@curefit/care-common";
import { Goal } from "@curefit/gmf-common";
import * as _ from "lodash";

import * as React from "react";
import { ISavePlanResponse } from "../../../../common/models/ISavePlanResponse";
import { ActionResult } from "../../../../common/models/IGenericWorkflowActionResult";
import { ApiManager } from "../../api/ApiManager";
import { EHRRequestMapper } from "../../api/EHRRequestMapper";
import LifestylePlan from "../../components/templates/LifestylePlan";
import AppLoader from "../../components/utils/AppLoader";
import IDoctorProfile from "../../models/IDoctorProfile";
import { IOngoingConsultation } from "../../models/IOngoingConsultation";
import { IPatientVitalResponse } from "../../models/IPatientVitalResponse";
import IMetric from "../../models/metrics/IMetric";
import { IEHRSavePatientMedicalProfile } from "../../models/patients/IEHRSavePatientMedicalProfile";
import IPatientLifestylePlanWrapper from "../../models/patients/IPatientLifestylePlanWrapper";
import { IPdfTemplates } from "../../models/PdfTemplatesModels";
import IStaticData from "../../models/staticData/IStaticData";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import { AppConstants, AppMessages, ConsultationStatusConstant, ORION_IMG_URL, SUB_SECTIONS_CONTEXT_KEY, toastNotificationAppearance } from "../../utils/AppConstants";
import { default as AppUtils, LOADING_STATE } from "../../utils/AppUtils";
import { EventNames } from "../../utils/EventTrackerConstants";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { Tracker } from "../../utils/Tracker";
import { default as CTA, CTATheme } from "../../components/common/CallToAction";
import CommonPrescriptionPdf from "../../components/templates/CommonPrescriptionPdf";
import { Position } from "react-bootstrap";
export interface ReviewPdfProps {
    appointmentId: number,
    doctorProfile: IDoctorProfile
    doctorType: string,
    patientId: number,
    secondaryUserId: string,
    bookingId: number,
    ongoingConsultation: IOngoingConsultation,
    patientVitals: IPatientVitalResponse[],
    staticSpecialities: any[],
    staticlifestylePlanHabits: IStaticData;
    toggleModal: (flag: boolean) => void,
    onPlanSaveFail: (errorText: string, isPdfDataSaved: boolean, pdfData: File, pdfPreviewdata: File) => void,
    onPlanSaveSuccess: (pdfData: File, pdfPreviewData: File) => void,
    updateAppointmentStatus: (bookingId: number, appointmentId: number, status: ConsultationStatusConstant) => Promise<any>,
    patientProfile: IPatientDetail,
    staticGoals: Goal[],
    staticMetrics: IMetric[],
    fetchPlanStaticData: () => void,
    saveUserPlan: (consultation: IAppointmentScheduleResponse, prescription: IPrescription, patientPlan: IPatientLifestylePlanWrapper, planId: string, isSelf?: boolean, medicalProfile?: any) => Promise<any>,
    removeWorkflowObject: (consultation: IAppointmentScheduleResponse, isPrescriptionObject: boolean) => Promise<any>
    staticSystemicExams: IStaticDataValue[],
    staticEntExams: IStaticDataValue[],
    savePrescriptionNew: (consultation: IAppointmentScheduleResponse, prescription: IPrescription, patientPlan: IPatientLifestylePlanWrapper, planId: string, isSelf: boolean) => Promise<any>,
    isPdfDataSaved: boolean,
    onPrescriptionSaveFail: (errorText: string, isPdfDataSaved: boolean, pdfData: File, pdfPreviewdata: File) => void,
    onPrescriptionSaveSuccess: (pdfData: File, pdfPreviewData: File) => void,
    printPdf: () => void,
    toggleSecondModal: (show: boolean) => void,
    pdfTemplates: IPdfTemplates,
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: IEHRSavePatientMedicalProfile, appointmentId: number, doctorType?: string) => Promise<any>
    getPlanData: any,
    uploadPdfAndCompleteConsultation: () => Promise<any>
}

export interface ReviewPdfState {
    pdfData: File,
    pdfPreviewData: File,
    pdfGenerationStatus: LOADING_STATE,
    pdfSaveStatus: LOADING_STATE, // check for pdf save
    pdfDataSaveStatus: LOADING_STATE, // check for prescription or plan pdf data save
    planSaveError: string,
    isStaticGoalsAndMetricsLoaded: LOADING_STATE,
    signatureImagePreSignedUrlMap: { [index: string]: DocSignatureMap }
}

export interface DocSignatureMap {
    fileCompletePath: string,
    url: string
}

class ReviewPdf extends React.Component<ReviewPdfProps, ReviewPdfState> {
    constructor(props: ReviewPdfProps) {
        super(props);
        let staticGoalsAndMetricsLoadingStatus = !_.isEmpty(props.staticGoals) && !_.isEmpty(props.staticMetrics) ? LOADING_STATE.LOADED : LOADING_STATE.NOT_INITIALIZED;
        this.state = {
            isStaticGoalsAndMetricsLoaded: staticGoalsAndMetricsLoadingStatus,
            pdfData: null,
            pdfPreviewData: null,
            pdfGenerationStatus: LOADING_STATE.LOADING,
            pdfSaveStatus: LOADING_STATE.NOT_INITIALIZED,
            pdfDataSaveStatus: props.isPdfDataSaved ? LOADING_STATE.LOADED : LOADING_STATE.NOT_INITIALIZED,
            planSaveError: null,
            signatureImagePreSignedUrlMap: null
        }
    }

    componentWillReceiveProps(nextProps: ReviewPdfProps) {
        if (!_.isEmpty(nextProps.staticGoals) && !_.isEmpty(nextProps.staticMetrics)) {
            this.setState({
                isStaticGoalsAndMetricsLoaded: LOADING_STATE.LOADED
            })
        }
    }

    componentDidMount() {
        AppUtils.closeChatContainer()
        if (this.state.isStaticGoalsAndMetricsLoaded !== LOADING_STATE.LOADED) {
            this.props.fetchPlanStaticData();
        }
        if (this.props.ongoingConsultation && this.props.ongoingConsultation.appointmentSchedule && this.props.ongoingConsultation.appointmentSchedule.consultationProduct) {
            let doctorIds: string[] = [];
            doctorIds.push(this.props.ongoingConsultation.appointmentSchedule.doctor.id.toString());
            if (this.props.ongoingConsultation.appointmentSchedule.consultationProduct.isPlan) {
                if (this.props.ongoingConsultation.planMeta && this.props.ongoingConsultation.planMeta.planMeta && this.props.ongoingConsultation.planMeta.planMeta.planSourceMeta) {
                    _.map(this.props.ongoingConsultation.planMeta.planMeta.planSourceMeta, (metaObject: any) => {
                        if (metaObject && metaObject.serviceId) {
                            doctorIds.push(metaObject.serviceId);
                        }
                    });
                } else {
                    console.log("NOT FOUND@@@@@@@@@@@")
                }
                if (doctorIds.length > 0) {
                    Promise.all(
                        doctorIds.map((doctorId: string) => ApiManager.getAlbusApis().getDoctorSignatureImageDownloadPreSignedUrl(Number(doctorId)))
                    ).then((response: any[]) => {
                        console.log("FETCHED ALL SIGNATURES", response)
                        if (response && response.length > 0) {
                            let docSignatureMap: { [index: string]: DocSignatureMap } = {};
                            response.map((signedSignObj: DocSignatureMap, index: number) => {
                                docSignatureMap[doctorIds[index]] = signedSignObj;
                            })
                            console.log("SIGNED URL MAP", docSignatureMap);
                            this.setState({
                                signatureImagePreSignedUrlMap: docSignatureMap
                            });
                        }
                    }).catch((err: any) => {
                        console.log("ERROR FETCHING SIGN", err)
                    })
                }
            } else {
                ApiManager.getAlbusApis().getDoctorSignatureImageDownloadPreSignedUrl(this.props.ongoingConsultation.appointmentSchedule.doctor.id).then((response: any) => {
                    let docSignatureMap: { [index: string]: DocSignatureMap } = {};
                    docSignatureMap[this.props.ongoingConsultation.appointmentSchedule.doctor.id] = response;
                    this.setState({
                        signatureImagePreSignedUrlMap: docSignatureMap
                    });
                }).catch((err: any) => {
                    throw (err)
                })
            }
        }
        // this.getPreSignedUrlForDoctorSignatureImage(this.props.doctorProfile.id);
    }

    preventModalClose = (event: any) => {
        event.stopPropagation();
    }

    savePhysioPrescription = () => {
        this.props.uploadPdfAndCompleteConsultation().then(() => {
            this.setState({ pdfDataSaveStatus: LOADING_STATE.LOADED });
            // Show Success Modal
            this.props.toggleSecondModal(true);
        }).catch(() => {
            let errorMsg = AppMessages.SAVE_PRESCRIPTION_UNSUCCESSFUL
            AppUtils.triggerToastNotification(errorMsg, toastNotificationAppearance.error)
        })
    }

    savePrescription = () => {
        // let prescription = this.props.ongoingConsultation.currentPrescription;
        let prescription = this.props.ongoingConsultation.medicalProfile && this.props.ongoingConsultation.medicalProfile.currentConsultationData ? EHRRequestMapper.getEHRSavePrescriptionRequestFromConfigBasedPrescription(this.props.ongoingConsultation.medicalProfile) : {};
        const isSelf = this.props.patientProfile.relationship && this.props.patientProfile.relationship.toUpperCase() === AppConstants.patientRelationships.SELF;
        this.setState({
            pdfDataSaveStatus: LOADING_STATE.LOADING
        }, () => {
            if (AppUtils.isPhysiotherapist(this.props.doctorType)) {
                this.savePhysioPrescription()
            } else {
                this.props.savePrescriptionNew(
                    this.props.ongoingConsultation.appointmentSchedule,
                    prescription,
                    null,
                    null,
                    isSelf
                ).then((saveResponse: ISavePlanResponse) => {
                    if (saveResponse.status === ActionResult.SUCCESS) {
                        Tracker.track(EventNames.Prescription_Save_Successful, { appointmentId: this.props.appointmentId });
                        return this.props.uploadPdfAndCompleteConsultation()
                    } else {
                        Tracker.track(EventNames.Prescription_Save_Failed, { appointmentId: this.props.appointmentId });
                        this.setState({ pdfDataSaveStatus: LOADING_STATE.LOADED });
                        return Promise.reject(saveResponse)
                    }
                }).then(() => {
                    Tracker.track(EventNames.Prescription_Upload_Done, { appointmentId: this.props.appointmentId });
                    // Prescription Data Saved
                    this.setState({ pdfDataSaveStatus: LOADING_STATE.LOADED });
                    // Show Success Modal
                    this.props.toggleSecondModal(true);
                }).catch((error) => {
                    Tracker.track(EventNames.Prescription_Save_Failed, { appointmentId: this.props.appointmentId });
                    let errorMsg = AppMessages.SAVE_PRESCRIPTION_UNSUCCESSFUL
                    if (!_.isEmpty(error) && !_.isEmpty(error.workflowStates)) {
                        errorMsg += ": " + AppUtils.getWorkflowFailureError(error.workflowStates);
                    }
                    AppUtils.triggerToastNotification(errorMsg, toastNotificationAppearance.error)
                    this.setState({ pdfDataSaveStatus: LOADING_STATE.LOADED });
                });
            }
        })
    };

    getMedicalProfileData = () => {
        let medicalProfile: { [key: string]: any } = {};
        const healthTarget = _.pick(this.props.ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.HEALTH_TARGET]);
        const otherGoals = _.pick(this.props.ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.OTHER_GOALS]);
        const patient_interventions = _.pick(this.props.ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.PATIENT_INTERVENTIONS]);
        const dietPlan = _.pick(this.props.ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.DIET_PLAN]);
        const fitnessPlan = _.pick(this.props.ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.FITNESS_PLAN]);
        const mindfulPlan = _.pick(this.props.ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.MINDFULNESS_PLAN]);
        const habits = _.pick(this.props.ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.HABITS]);
        const prescInst = _.pick(this.props.ongoingConsultation.medicalProfile.patientData.newConfigData, [SUB_SECTIONS_CONTEXT_KEY.PRESCRIPTION_INSTRUCTIONS]);
        if (!_.isEmpty(healthTarget)) medicalProfile = { ...medicalProfile, ...healthTarget };
        if (!_.isEmpty(otherGoals)) medicalProfile = { ...medicalProfile, ...otherGoals };
        if (!_.isEmpty(patient_interventions)) medicalProfile = { ...medicalProfile, ...patient_interventions };
        if (!_.isEmpty(dietPlan)) medicalProfile = { ...medicalProfile, ...dietPlan };
        if (!_.isEmpty(fitnessPlan)) medicalProfile = { ...medicalProfile, ...fitnessPlan };
        if (!_.isEmpty(mindfulPlan)) medicalProfile = { ...medicalProfile, ...mindfulPlan };
        if (!_.isEmpty(habits)) medicalProfile = { ...medicalProfile, ...habits };
        if (!_.isEmpty(prescInst)) medicalProfile = { ...medicalProfile, ...prescInst };
        return medicalProfile
    }

    savePatientPlan = () => {
        this.setState({
            pdfDataSaveStatus: LOADING_STATE.LOADING
        }, () => {
            let { ongoingConsultation } = this.props;
            let consultation = ongoingConsultation.appointmentSchedule;
            let planId = !_.isEmpty(ongoingConsultation.planMeta) ? ongoingConsultation.planMeta._id : null;
            const medicalProfile = this.getMedicalProfileData();
            let patientPlan = AppUtils.isLifeStyleConsultation(this.props.ongoingConsultation.appointmentSchedule) ? medicalProfile : ongoingConsultation.medicalProfile.currentConsultationData;
            this.props.saveUserPlan(consultation, null, patientPlan, planId, null, medicalProfile).then((planSaveResponse: ISavePlanResponse) => {
                if (planSaveResponse.status === ActionResult.SUCCESS) {
                    Tracker.track(EventNames.Plan_Save_Successful, { appointmentId: this.props.appointmentId });
                    return this.props.uploadPdfAndCompleteConsultation()
                }
                else {
                    return Promise.reject(planSaveResponse)
                    // const errorMsg = AppUtils.getWorkflowFailureError(planSaveResponse.workflowStates);
                    // this.props.onPlanSaveFail(errorMsg || "Something went wrong", false, this.state.pdfData, this.state.pdfPreviewData);
                }
            }).then(() => {
                Tracker.track(EventNames.Prescription_Upload_Done, { appointmentId: this.props.appointmentId });
                // Plan Data Saved
                this.setState({ pdfDataSaveStatus: LOADING_STATE.LOADED });
                // Show Success Modal
                this.props.toggleSecondModal(true);
            }).catch((error: any) => {
                Tracker.track(EventNames.Plan_Save_Error, { appointmentId: this.props.appointmentId });
                let errorMsg = AppMessages.SAVE_PRESCRIPTION_UNSUCCESSFUL
                if (!_.isEmpty(error) && !_.isEmpty(error.workflowStates)) {
                    errorMsg += ": " + AppUtils.getWorkflowFailureError(error.workflowStates);
                }
                AppUtils.triggerToastNotification(errorMsg, toastNotificationAppearance.error)
                this.setState({ pdfDataSaveStatus: LOADING_STATE.LOADED });
            });
        })
    }

    closeModal = () => {
        this.props.toggleModal(false);
    };

    handleSaveClick = () => {
        Tracker.track(EventNames.Plan_Save_Clicked, { appointmentId: this.props.appointmentId });
        if (this.props.ongoingConsultation.appointmentSchedule.consultationProduct.isPlan) {
            this.savePatientPlan()
        } else {
            this.savePrescription()
        }
    };

    generatePDF = (isPreview: boolean) => {
        const { isPlan } = this.props.ongoingConsultation.appointmentSchedule.consultationProduct;
        const pdfTemplateClassName = isPlan
            ? isPreview
                ? AppConstants.Templates["PATIENT_PLAN_PREVIEW"]
                : AppConstants.Templates["PATIENT_PLAN"]
            : isPreview
                ? AppConstants.Templates["PATIENT_PRESCRIPTION_PREVIEW"]
                : AppConstants.Templates["PATIENT_PRESCRIPTION"];
        this.setState({
            pdfGenerationStatus: LOADING_STATE.LOADED
        })
    };

    handleTryAgainOnClick = () => {
        if (this.state.pdfGenerationStatus !== LOADING_STATE.LOADING && this.state.pdfSaveStatus !== LOADING_STATE.LOADING) {
            this.generatePDF(false); // Generate PDF for mail and to show in modal
        }
        this.generatePDF(true); // Generate PDF for printing
    };

    render() {
        const hasOngoingDetails = !_.isEmpty(this.props.ongoingConsultation);
        const patientMedicalProfileData = hasOngoingDetails ? { ...this.props.ongoingConsultation.medicalProfile } : {};
        const patientPlan = hasOngoingDetails ? { ...this.props.ongoingConsultation.patientPlan } : null;
        const patientGoals = (hasOngoingDetails && this.props.ongoingConsultation.medicalProfile && this.props.ongoingConsultation.medicalProfile.patientData && this.props.ongoingConsultation.medicalProfile.patientData.newConfigData && this.props.ongoingConsultation.medicalProfile.patientData.newConfigData.healthTarget && this.props.ongoingConsultation.medicalProfile.patientData.newConfigData.healthTarget.goals) || {};
        const patientSecondaryGoals = (hasOngoingDetails && this.props.ongoingConsultation.medicalProfile && this.props.ongoingConsultation.medicalProfile.patientData && this.props.ongoingConsultation.medicalProfile.patientData.newConfigData && this.props.ongoingConsultation.medicalProfile.patientData.newConfigData.otherGoals && this.props.ongoingConsultation.medicalProfile.patientData.newConfigData.otherGoals.otherGoals) || [];
        const patientInterventions = (hasOngoingDetails && this.props.ongoingConsultation.medicalProfile && this.props.ongoingConsultation.medicalProfile.patientData && this.props.ongoingConsultation.medicalProfile.patientData.newConfigData && this.props.ongoingConsultation.medicalProfile.patientData.newConfigData.patientInterventions && this.props.ongoingConsultation.medicalProfile.patientData.newConfigData.patientInterventions.patientInterventions) || [];
        const planMeta = hasOngoingDetails ? this.props.ongoingConsultation.planMeta : null;
        const { appointmentId } = this.props;
        const isPlan = !_.isEmpty(this.props.ongoingConsultation.appointmentSchedule) ? this.props.ongoingConsultation.appointmentSchedule.consultationProduct.isPlan : false;
        const pdfSaveInProgress = this.state.pdfSaveStatus === LOADING_STATE.LOADING || this.state.pdfDataSaveStatus === LOADING_STATE.LOADING;
        const patientMetrics = !_.isEmpty(this.props.ongoingConsultation.patientMetrics) ? this.props.ongoingConsultation.patientMetrics : null;

        let pdfPrescription = null, systemicExaminations = null, examinations = null, entExaminations = null, prescriptionSignatureObj = null, allergies: any = null;
        let hideHeaderFooter = false;
        if (!isPlan) {
            if (hasOngoingDetails && this.props.ongoingConsultation.medicalProfile) {
                pdfPrescription = { ...this.props.ongoingConsultation.medicalProfile };
                pdfPrescription.prescription = this.props.ongoingConsultation.medicalProfile.currentConsultationData ? { ...this.props.ongoingConsultation.medicalProfile.currentConsultationData } : null;
            }

            if (hasOngoingDetails && this.props.ongoingConsultation.medicalProfile && this.props.ongoingConsultation.medicalProfile.currentConsultationData) {
                systemicExaminations = this.props.ongoingConsultation.medicalProfile.currentConsultationData.systemicExaminations || {};
                examinations = this.props.ongoingConsultation.medicalProfile.currentConsultationData.generalExaminations || {};
                entExaminations = this.props.ongoingConsultation.medicalProfile.currentConsultationData.entExaminations || {};
                allergies = this.props.ongoingConsultation.medicalProfile.currentConsultationData.allergies || {};
                // allergies = !_.isEmpty(this.props.ongoingConsultation.medicalProfile.currentConsultationData.allergies) && !_.isEmpty(this.props.ongoingConsultation.medicalProfile.currentConsultationData.allergies.allergenList) ? this.props.ongoingConsultation.medicalProfile.currentConsultationData.allergies.allergenList : null;
            }

            if (AppUtils.isDefined(this.state.signatureImagePreSignedUrlMap)) {
                prescriptionSignatureObj = this.state.signatureImagePreSignedUrlMap[this.props.ongoingConsultation.appointmentSchedule.doctor.id]
            }
        }
        const isPhysio = AppUtils.isPhysiotherapist(this.props.doctorType);
        return (
            <div className={"review-prescription-container"} onClick={this.preventModalClose}>
                <div className={"cancel-modal"} onClick={this.closeModal}>x</div>
                {
                    this.state.isStaticGoalsAndMetricsLoaded === LOADING_STATE.LOADED &&
                    <div>
                        <div style={{ overflow: "hidden" }}>
                            {/*Prescription PDF template*/}
                            {!isPlan && ((pdfPrescription && pdfPrescription.prescription) || (this.props.ongoingConsultation.medicalProfile && this.props.ongoingConsultation.medicalProfile.currentConsultationData)) &&
                                <CommonPrescriptionPdf
                                    pdfTemplates={this.props.pdfTemplates}
                                    isPhysioConsultation={isPhysio}
                                    isTreatmentPlan={false}
                                    consultationData={{
                                        vitals: this.props.patientVitals,
                                        examinations: examinations,
                                        systemicExaminations: systemicExaminations,
                                        entExaminations: entExaminations,
                                        allergies: allergies,
                                        appointmentSchedule: this.props.ongoingConsultation.appointmentSchedule,
                                        patient: this.props.patientProfile,
                                        signatureImagePreSignedUrl: prescriptionSignatureObj,
                                        staticSystemicExams: this.props.staticSystemicExams,
                                        staticEntExams: this.props.staticEntExams,
                                        staticSpecialistData: this.props.staticSpecialities,
                                        medicalProfile: this.props.ongoingConsultation.medicalProfile,
                                        consultation: pdfPrescription
                                    }}
                                    hideHeaderFooter={false}
                                    renderHandler={() => this.generatePDF(false)}
                                />
                            }
                            {/* Plan PDF */}
                            {isPlan &&
                                <LifestylePlan
                                    patient={this.props.patientProfile}
                                    consultation={this.props.ongoingConsultation.appointmentSchedule}
                                    patientPlan={patientPlan}
                                    patientMedicalProfileData={patientMedicalProfileData}
                                    patientGoals={patientGoals}
                                    patientSecondaryGoals={patientSecondaryGoals}
                                    hideHeaderFooter={false}
                                    renderHandler={() => this.generatePDF(false)}
                                    vitals={this.props.patientVitals}
                                    staticSpecialistData={this.props.staticSpecialities}
                                    staticLifestyleHabits={this.props.staticlifestylePlanHabits.values}
                                    staticGoals={this.props.staticGoals}
                                    staticMetrics={this.props.staticMetrics}
                                    planMeta={planMeta}
                                    patientMetrics={patientMetrics}
                                    signatureImagePreSignedUrlMap={this.state.signatureImagePreSignedUrlMap}
                                />
                            }
                        </div>
                    </div>
                }
                {/*<div className={"action-icons"}>*/}
                {/*<div className={"continue-editing"}>*/}
                {/*<input className={"animated fadeInRight"}*/}
                {/*type="button"*/}
                {/*value="Edit"*/}
                {/*onClick={() => this.props.toggleModal(false)}/>*/}
                {/*<input className={"animated fadeInRight"}*/}
                {/*type="button"*/}
                {/*value="Generate PDF"*/}
                {/*onClick={() => this.generatePDF(true)}/>*/}
                {/*</div>*/}
                {/*</div>*/}
                {
                    isPlan && this.state.isStaticGoalsAndMetricsLoaded === LOADING_STATE.LOADING &&
                    <AppLoader />
                }
                {
                    this.state.pdfSaveStatus !== LOADING_STATE.LOADING &&
                    <div className={"pdf-generation-status"}>
                        {
                            this.state.pdfGenerationStatus === LOADING_STATE.LOADING &&
                            <div className={"pdf-generating"}>
                                <span>
                                    <img src={ORION_IMG_URL + "loader/rolling-loader.gif"} />
                                    <div>Generating PDF</div>
                                </span>
                            </div>
                        }
                    </div>
                }
                {
                    pdfSaveInProgress &&
                    <div className={"pdf-upload-status"}>
                        <AppLoader text={!isPlan ? "Saving Prescription" : "Saving PDF"} />
                    </div>
                }
                {
                    this.state.pdfGenerationStatus !== LOADING_STATE.LOADING &&
                    this.state.pdfSaveStatus !== LOADING_STATE.LOADING &&
                    this.state.pdfDataSaveStatus !== LOADING_STATE.LOADING &&
                    <div className={"action-icons"}>
                        {
                            this.state.pdfGenerationStatus === LOADING_STATE.NOT_INITIALIZED &&
                            <div className={"pdf-failed animated fadeInRight"}>
                                <span><span className="glyphicon glyphicon-info-sign" /> PDF Generation failed</span>
                            </div>
                        }
                        <div className={"continue-editing"}>
                            <CTA
                                innerText={"Edit"}
                                theme={CTATheme.SECONDARY}
                                onClick={() => {
                                    LocalStorageUtils.setClickEvents({ section: EventNames.Complete_Prescription, widget: !isPlan ? EventNames.Review_Prescription : "Plan", field: EventNames.Edit })
                                    this.props.toggleModal(false)
                                }}
                                customStyle={{ width: 140, display: "inline-block", animationDuration: "0.4s", animationName: "fadeInRight", animationFillMode: "both" }} />
                            {/*<input className={"cf-btn-rounded-bordered animated fadeInRight"}*/}
                            {/*type="button"*/}
                            {/*value="Edit"*/}
                            {/*onClick={() => {*/}
                            {/*LocalStorageUtils.setClickEvents({ section: EventNames.Complete_Prescription, widget: !isPlan ? EventNames.Review_Prescription : "Plan", field: EventNames.Edit })*/}
                            {/*this.props.toggleModal(false)*/}
                            {/*}}*/}
                            {/*/>*/}
                            {/*<input className={"animated fadeInRight"}*/}
                            {/*type="button"*/}
                            {/*value="Generate PDF"*/}
                            {/*onClick={() => this.generatePDF(true)}/>*/}
                        </div>
                        {
                            this.state.pdfGenerationStatus !== LOADING_STATE.NOT_INITIALIZED ?
                                <div className={"send-prescription"}>
                                    <CTA
                                        innerText={isPlan ? "Proceed to completion" : "Complete"}
                                        theme={CTATheme.PRIMARY}
                                        onClick={() => {
                                            LocalStorageUtils.setClickEvents({ section: EventNames.Complete_Prescription, widget: !isPlan ? EventNames.Review_Prescription : "Plan", field: EventNames.Complete })
                                            this.handleSaveClick()
                                        }}
                                        customStyle={{ width: 140, display: "inline-block", animationDuration: "0.4s", animationName: "fadeInRight", animationFillMode: "both" }} />
                                </div> :
                                <div className={"generate-prescription"}>
                                    <CTA
                                        innerText={"Try Again"}
                                        theme={CTATheme.PRIMARY}
                                        onClick={this.handleTryAgainOnClick}
                                        customStyle={{ width: 140, display: "inline-block", animationDuration: "0.4s", animationName: "fadeInRight", animationFillMode: "both" }} />
                                    {/*<input className={"animated fadeInRight"}*/}
                                    {/*type="button"*/}
                                    {/*value="Try again"*/}
                                    {/*onClick={this.handleTryAgainOnClick} />*/}
                                </div>
                        }
                    </div>
                }
            </div>
        )

    }
}

export default ReviewPdf;